// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._75a6a2{line-height:1.75;font-size:calc(1em + var(--scale)*.2em)}._75a6a2 h2,._75a6a2 h3,._75a6a2 h4,._75a6a2 h5,._75a6a2 h6{font-size:calc(1em + var(--scale)*.5em);margin-top:var(--medium-spacer)}._75a6a2 ul{list-style:disc;padding-left:1.25em}*+._75a6a2 ul{margin-top:var(--spacer)}._75a6a2 ul>li+li{margin-top:1em}", ""]);
// Exports
exports.locals = {
	"formatted": "_75a6a2"
};
module.exports = exports;
